import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import { Link } from 'react-router-dom';


export default class IconButton extends React.Component {
  static propTypes = {
    active: PropTypes.bool,
    block: PropTypes.bool,
    color: PropTypes.string,
    disabled: PropTypes.bool,
    outline: PropTypes.bool,
    tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    getRef: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    onClick: PropTypes.func,
    size: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string.isRequired,
    cssModule: PropTypes.object,
    icon: PropTypes.string,
    to: PropTypes.string,
  };

  static defaultProps = {
    color: 'secondary',
    tag: 'button',
    icon: undefined,
    active: undefined,
    block: undefined,
    disabled: undefined,
    outline: undefined,
    getRef: undefined,
    onClick: undefined,
    size: undefined,
    cssModule: undefined,
    children: undefined,
    to: undefined,
  };

  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    if (this.props.disabled) {
      e.preventDefault();
      return;
    }

    if (this.props.onClick) {
      this.props.onClick(e);
    }
  }

  render(): React.ReactNode {
    const {
      active,
      block,
      className,
      cssModule,
      color,
      outline,
      size,
      tag: Tag,
      getRef,
      to,
      ...attributes
    } = this.props;
    if (to === undefined) {
      return (
        <button to={to} onClick={this.onClick} className={this.props.className} {...attributes}>
          <Isvg className="align-middle" src={this.props.icon} />
          <span className="align-middle icon-button-text">{this.props.children}</span>
        </button>
      );
    }
    return (
      <Link to={to} onClick={this.onClick} className={this.props.className} {...attributes}>
        <Isvg className="align-middle" src={this.props.icon} />
        <span className="align-middle icon-button-text">{this.props.children}</span>
      </Link>
    );
  }
}
